// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__2JuTq","content":"carousel_content__1C4Xe","control":"carousel_control__1aPVW"};